import Cookies from "universal-cookie";

export function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

const getTotalVat = (receipt) => {
  let totalVat = 0;
  receipt.vat.forEach((vat) => {
    totalVat = totalVat + vat.amountRaw;
  });
  return totalVat;
};

const cookies = new Cookies(null, { path: "/" });
const COOKIE_BASE_NAME = "checkout-transaction-pushed";
const getCookieName = (receipt) => `${COOKIE_BASE_NAME}-${receipt.saleId}`;

export const mayPushTransaction = (receipt) => {
  if (receipt === undefined || receipt.saleId === undefined) return;

  const cookie = cookies.get(getCookieName(receipt));
  if (cookie === undefined) return true;

  console.log("tgm purchase - duplicate push prevented");
  return false;
};

export const setTransactionAsPushed = (receipt) => {
  if (receipt === undefined || receipt.saleId === undefined) return;

  let expires = new Date();
  expires.setDate(expires.getDate() + 90);

  cookies.set(getCookieName(receipt), receipt.saleId, {
    expires: expires,
  });
};

export const tagManagerPurchase = (receipt, dataLayer, useGA4) => {
  if (receipt && dataLayer && !useGA4) {
    const actionField = {
      id: receipt.saleId,
      revenue: receipt.sumInclVatRaw,
      tax: getTotalVat(receipt),
      currency:
        receipt.payments.length > 0 ? receipt.payments[0].currency.name : "SEK",
    };
    const products = receipt.articles.map((a) => {
      return {
        name: a.name,
        id: `${a.plu}`,
        quantity: a.quantity,
        price: parseFloat(a.displayPricePerPieceInclVatRaw),
      };
    });

    dataLayer.push({
      event: "transaction",
      ecommerce: {
        purchase: {
          actionField,
          products,
        },
      },
    });
    console.log(
      "tgm purchase pushed:",
      dataLayer.find((l) => l.event === "transaction")
    );
  }

  if (receipt && dataLayer && useGA4) {
    const products = receipt.articles.map((a) => {
      return {
        name: a.name,
        id: `${a.plu}`,
        quantity: a.quantity,
        price: parseFloat(a.displayPricePerPieceInclVatRaw),
      };
    });

    const actionField = {
      event: "purchase",
      ecommerce: {
        transaction_id: receipt.saleId,
        value: receipt.sumInclVatRaw, //includes tax and shipping
        subtotalValue: receipt.sumExclVatRaw, //excludes tax and shipping
        tax: getTotalVat(receipt),
        currency:
          receipt.payments.length > 0
            ? receipt.payments[0].currency.name
            : "SEK",
        payment_type: receipt.payments?.[1]?.paymentMethodName
          ? receipt.payments?.[1]?.paymentMethodName
          : receipt.payments[0]?.paymentMethodName,
        items: products,
      },
    };

    dataLayer.push(actionField);
    console.log(
      "tgm purchase pushed:",
      dataLayer.find((l) => l.event === "purchase")
    );
  }
};

export const tagManagerInit = (posId, config) => {
  let tgm = window.document.createElement("script");
  tgm.setAttribute("type", "text/javascript");
  tgm.setAttribute(
    "src",
    `${config.baseUrl}/ee-static/checkout/pos-${posId}/Scripts/tgm.js`
  );
  window.document.getElementsByTagName("head")[0].appendChild(tgm);
  console.log("tgm initiated");
};
